import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import Accordion from "@mui/material/Accordion"
import AccordionActions from "@mui/material/AccordionActions"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Button from "@mui/material/Button"
import Divider from "@mui/material/Divider"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useConfirm } from "material-ui-confirm"
import React, { useMemo, useState } from "react"
import ReactCrop from "react-image-crop"
import "react-image-crop/dist/ReactCrop.css"
import { shallowEqual, useDispatch, useSelector } from "react-redux"
import { phaseInsert, servicePackageDelete, servicePackageUpdate } from "../store/actions"
import { selectPhasesByServicePackageId } from "../store/reducers/phaseReducer"
import { selectPackageById } from "../store/reducers/servicePackageReducer"
import PhaseCard from "./PhaseCard"

export const Package = (props) => {
	//const classes = useStyles();
	const { packageId, styles } = props
	const dispatch = useDispatch()
	const confirm = useConfirm()

	const [crop, setCrop] = useState({ x: 0, y: 0, width: 100, height: 100, unit: "%" })
	const [isExpanded, setIsExpanded] = useState(false)

	const servicePackage = useSelector((state) => selectPackageById(state, packageId), shallowEqual)
	const spObj = useMemo(() => servicePackage, [servicePackage])

	const phases = useSelector((state) => selectPhasesByServicePackageId(state, packageId))
	const phaseMemo = useMemo(() => (phases ? phases : []), [phases])

	const spUpdate = (json, id) => dispatch(servicePackageUpdate(json, id))
	const spDelete = (id) => dispatch(servicePackageDelete(id))
	const pInsert = (spid) => dispatch(phaseInsert(phaseMemo, spid))

	const showHideDetail = () => {
		setIsExpanded(!isExpanded)
	}

	const sortedPhases = phaseMemo.sort((a, b) => (Number(a["phaseorder"]) > Number(b["phaseorder"]) ? 1 : -1))

	return (
		<Accordion sx={styles.root} expanded={isExpanded} TransitionProps={{ unmountOnExit: true }}>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls={"panel" + packageId + "a-content"}
				id={"panel" + packageId}
				onClick={showHideDetail}>
				<Typography variant="h6">
					{spObj.title} - {spObj.description}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				<Grid container display="flex" flexDirection={"column"} justifyContent="space-between" alignItems={"stretch"}>
					<Grid container item display="flex" flexDirection={"row"}>	
						<Grid item sx={styles.text}>
							<Typography component={"span"} variant={"body1"} display={"flex"} flexDirection={"column"}>
								<TextField
									label="Otsikko"
									InputLabelProps={{ shrink: true }}
									variant="outlined"
									id={"title" + packageId}
									onBlur={(e) => spUpdate({ title: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.title}
									sx={{ width: 500 }}></TextField>
								<TextField
									label="Kuvaus"
									InputLabelProps={{ shrink: true }}
									variant="outlined"
									id={"description" + packageId}
									onBlur={(e) => spUpdate({ description: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.description}
									sx={{ width: 500 }}></TextField>
								<TextField
									multiline
									label="Tarkka Kuvaus"
									InputLabelProps={{ shrink: true }}
									variant="outlined"
									id={"longdescription" + packageId}
									onBlur={(e) => spUpdate({ longdescription: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.longdescription}
									sx={{ width: 500 }}
									minRows={3}
									maxRows={10}
								/>
								<TextField
									label="Kommentti (vain Admineille)"
									InputLabelProps={{ shrink: true }}
									variant="outlined"
									multiline
									id={"admindescription" + packageId}
									onBlur={(e) => spUpdate({ admindescription: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.admindescription}
									sx={{ width: 500 }}></TextField>
								<TextField
									label="Hinta"
									variant="outlined"
									InputLabelProps={{ shrink: true }}
									type="number"
									id={"totalcost" + packageId}
									onBlur={(e) => spUpdate({ totalcost: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.costperunit}
									sx={{ width: 500 }}></TextField>
								<TextField
									label="Paketin kuva (URL)"
									variant="outlined"
									InputLabelProps={{ shrink: true }}
									type="url"
									id={"url" + packageId}
									sx={{ width: 500 }}
									onBlur={(e) => spUpdate({ img_url: e.target.value }, spObj.servicepackageid)}
									defaultValue={spObj.img_url}></TextField>
							</Typography>
						</Grid>
						<Grid width="50%" item p={2}>
							{spObj.img_url !== null && spObj.img_url !== undefined && spObj.img_url !== "" && (
								

								<ImageCropper
									src={spObj.img_url}
									setCrop={setCrop}
									crop={crop}
									spUpdate={spUpdate}
									servicepackageid={spObj.servicepackageid}
									/>

							)}
						</Grid>
					</Grid>
					<Grid item>
						<Grid container direction="row">
							{sortedPhases.length > 0 &&
								phaseMemo.map((phaseObj, index) => {
									return (
										<PhaseCard
											key={phaseObj.phaseid}
											phaseObj={phaseObj}
											index={index}
											packageId={spObj.servicepackageid}
										/>
									)
								})}
						</Grid>
					</Grid>
				</Grid>
			</AccordionDetails>
			<Divider />
			<AccordionActions>
				<Button size="small" onClick={() => pInsert(spObj.servicepackageid)}>
					Lisää Vaihe
				</Button>
				<Button
					size="small"
					onClick={() => {
						confirm({
							title: "Haluatko poistaa paketin?",
							description:
								"Tämä poistaa paketin ja kaikki siihen liittyvät vaiheet. Toimintoa ei voi peruuttaa tietokanta tallennuksen jälkeen.",
							confirmationText: "Kyllä",
							cancellationText: "Peruuta",
						}).then(() => {
							spDelete(spObj.servicepackageid)
						})
					}}>
					Poista Paketti
				</Button>
				<Button size="small" onClick={showHideDetail}>
					Sulje
				</Button>
			</AccordionActions>
		</Accordion>
	)
}

export const ImageCropper = ({ src, crop, setCrop, spUpdate, servicepackageid }) => {
	const handleChange = () => {
		spUpdate({ img_crop: JSON.stringify(crop) }, servicepackageid)
	}
	return (
		<ReactCrop crop={crop} onChange={(_, percentCrop) => setCrop(percentCrop)} aspect={3 / 4} onDragEnd={handleChange} style={{ maxHeight: "450px"}}>
			<img src={src} alt="Lisää kuva" />
		</ReactCrop>
	)
}
